import React from "react";
import { useAuth } from "../../hooks/useAuth";

/**
 * Friendly "sign in to continue" surface for `/files` when the visitor is
 * logged out. Deliberately not the 404 page — this page's existence isn't
 * secret, it's just gated.
 */
export const SignInPrompt: React.FC = () => {
  const { signIn } = useAuth();

  return (
    <div
      data-testid="my-files-sign-in-prompt"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "60vh",
        gap: "0.75rem",
        padding: "2rem",
        color: "var(--mf-text)",
      }}
    >
      <h1 style={{ fontSize: "1.5rem", margin: 0 }}>
        Sign in to see your files
      </h1>
      <p style={{ color: "var(--mf-text-muted)", maxWidth: "24rem" }}>
        My Files keeps every mindmap you save to the cloud, ready to reopen from
        anywhere.
      </p>
      <button
        type="button"
        onClick={() => signIn("notion")}
        style={{
          marginTop: "0.5rem",
          background: "var(--mf-accent)",
          color: "var(--mf-accent-text)",
          padding: "0.65rem 1.25rem",
          borderRadius: "0.375rem",
          fontSize: "0.9rem",
          fontWeight: 600,
          border: "none",
          cursor: "pointer",
        }}
      >
        Sign in
      </button>
      <a
        href="/"
        style={{
          color: "var(--mf-accent)",
          fontSize: "0.85rem",
          textDecoration: "none",
        }}
      >
        Back to Mindmap.so
      </a>
    </div>
  );
};

export default SignInPrompt;
